export default "__VITE_ASSET__312c8cb9__"